import { onMount } from "solid-js";
import { useUserContext } from "./UserContextProvider";
import en from '../en.json';
import de from '../de.json';

export default function LanguageChooser() {

    const { switchLanguage } = useUserContext();

    function setLanguage(lang: string) {
        document.cookie = `lang=${lang}; path=/; max-age=31536000`;
        switchLanguage(lang === "en" ? en : de);
    }

    onMount(() => {
        const cookies = document.cookie.split('; ').find(row => row.startsWith('lang='));
        const savedLang = cookies ? cookies.split('=')[1] : 'de'; // Default to German
        setLanguage(savedLang);
    });

    function languageSelectChanged(e: any) {
        setLanguage(e.target.value);
    }

    return (
        <div class="language-chooser">
            <label for="language-select" class="language-label">
                <i class="fa-solid fa-earth-europe"></i>
            </label>
            <select 
                id="language-select" 
                onChange={languageSelectChanged} 
                class="language-select" 
                value={document.cookie.split('; ').find(row => row.startsWith('lang='))?.split('=')[1] || 'de'}
            >
                <option value="de">Deutsch</option>
                <option value="en">English</option>
            </select>
        </div>
    )
}
